import { render, staticRenderFns } from "./FormatSelection.vue?vue&type=template&id=156c3ab3&scoped=true&"
import script from "./FormatSelection.vue?vue&type=script&lang=js&"
export * from "./FormatSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c3ab3",
  null
  
)

export default component.exports